import { AppShell } from '../components/AppShell';
import { ProfileThreadOpener } from '../components/symphony/profile-links/ProfileThreadOpener';

// `/profile-thread?handle=&context=` — a signed-in visitor opening a Symphony profile link on the web; it
// opens the profile thread and forwards into it (docs/symphony-profile-links-design.md §6.1). Tenant-free in
// lib/onboarding-gate.js, so a brand-new account opens the thread before onboarding, as on the phones.
export default function ProfileThreadPage() {
  return (
    <AppShell>
      <ProfileThreadOpener />
    </AppShell>
  );
}
